import { useMemo } from 'react';

export type ApolloMqOption = { value: string; label: string };

/**
 * Apollo MQ 配置选项（VHost / 队列）。
 * 待后端提供配置读取接口后在此接入；当前返回空列表。
 */
export function useApolloMqConfig() {
  const vhostOptions = useMemo<ApolloMqOption[]>(() => [], []);
  const queueOptions = useMemo<ApolloMqOption[]>(() => [], []);

  return {
    vhostOptions,
    queueOptions,
    loading: false,
  };
}
